import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class JobService {

    static getJobListResult(CompanyCode, list, ActionType) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType
        }  
        return axios.post( BaseUrl+'Job', data);
    }

    static SaveJob(CompanyCode, list,ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType: ActionType
        }  
        return axios.post( BaseUrl + 'SaveJob?email='+email, data);
    }
}



// WEBPACK FOOTER //
// ./src/Services/JobService/jobService.js